import React, { useState } from 'react';
import cn from 'classnames';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';
import { TbBuildingFactory2 } from 'react-icons/tb';
import { translate } from '@utils/i18n';
import styles from './index.module.scss';
import { IUserCompany } from 'ducks/user/reducers';
import { useUserCompanies } from '_clean-code/api/hooks/useUserCompanies';

interface CompanySelectionProps {
  className?: string;
}

function CompanySelection(props: CompanySelectionProps) {
  const {
    data: companies,
    switchCompany,
    selectedCompany
  } = useUserCompanies();
  const [isOpen, setIsOpen] = useState(false);

  const handleDropdownToggle = () => {
    setIsOpen(!isOpen);
  };

  const onSelectOption = (company: IUserCompany) => {
    if (company.companyId === selectedCompany?.companyId) {
      setIsOpen(false);
      return;
    }
    switchCompany(company);
  };

  if (!companies || !selectedCompany || companies.length === 1) {
    return null;
  }

  return (
    <div className={cn(styles.root, props.className)}>
      <Dropdown
        nav
        inNavbar
        isOpen={isOpen}
        toggle={handleDropdownToggle}
        className={cn('language', props.className)}
      >
        <DropdownToggle nav>
          <button className={styles.button} type="button">
            <TbBuildingFactory2 className={styles.plantIcon} />
            {selectedCompany.companyName}
          </button>
        </DropdownToggle>
        <DropdownMenu right>
          <div className={styles.menuTitle}>{translate('select_a_plant')}</div>
          {companies.map((company) => (
            <DropdownItem
              key={company.companyId}
              className="d-flex align-items-center"
              onClick={() => onSelectOption(company)}
            >
              <span>{company.companyName}</span>
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
}

export default CompanySelection;
